/**
 * @ticket TM-1000001975
 *
 * Allocation order strategy for Payment Distribution (Verteilung).
 * Mirrors the backend enum {@code bd.BdDunningDistributionAllocationOrder}
 * (configured on {@code bd.DunningType.paymentDistributionAllocationOrder}).
 *
 * Ordinal values are STABLE and MUST match the backend ordinal exactly.
 * NEVER reorder or assign explicit values.
 *
 *   0 — OLDEST_FIRST:                oldest open positions are covered first.
 *   1 — DUNNING_LEVEL:               positions at higher dunning levels first.
 *   2 — CHARGES_FIRST_THEN_PREMIUM:  accrued charges covered before premium.
 */
export enum BdDunningDistributionAllocationOrderEnum {
    OLDEST_FIRST,                  // 0
    DUNNING_LEVEL,                 // 1
    CHARGES_FIRST_THEN_PREMIUM     // 2
}
